import React, { useState } from "react";
import { API_BASE_URL } from "../../config";

const SupportOtpPanel = ({ token }) => {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [message, setMessage] = useState("");
  const [verified, setVerified] = useState(false);
  const [loading, setLoading] = useState(false);

  const sendOtp = async () => {
    setLoading(true);
    setMessage("");
    setVerified(false);

    try {
      const res = await fetch(`${API_BASE_URL}/api/support/send-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (!res.ok) {
        setMessage(data.error || "Failed to send code");
        return;
      }

      setMessage("Support verification code sent ✅");
    } catch (err) {
      console.error(err);
      setMessage("Error sending code ❌");
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async () => {
    setLoading(true);
    setMessage("");
    setVerified(false);

    try {
      const res = await fetch(`${API_BASE_URL}/api/support/verify-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ email, code }),
      });

      const data = await res.json();

      if (!res.ok) {
        setMessage(data.error || "Invalid or expired code");
        return;
      }

      setVerified(true);
      setMessage(data.message || "User verified for support ✅");
    } catch (err) {
      console.error(err);
      setMessage("Error verifying code ❌");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={boxStyle}>
      <h3 style={{ marginTop: 0 }}>Caller Support Verification</h3>

      <p style={{ color: "#555" }}>
        Send a code to the user’s account email. The caller must read it back before sensitive support help.
      </p>

      <input
        style={inputStyle}
        type="email"
        placeholder="User account email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <button
        style={buttonStyle("#2e7d32")}
        onClick={sendOtp}
        disabled={loading || !email}
      >
        Send support verification code
      </button>

      <input
        style={inputStyle}
        placeholder="6-digit code"
        value={code}
        onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
      />

      <button
        style={buttonStyle("#1565c0")}
        onClick={verifyOtp}
        disabled={loading || !email || code.length !== 6}
      >
        Verify code
      </button>

      {message && (
        <p style={verified ? successStyle : messageStyle}>
          {message}
        </p>
      )}
    </div>
  );
};

const boxStyle = {
  background: "#f8fff8",
  border: "1px solid #c8e6c9",
  borderRadius: "10px",
  padding: "16px",
  marginBottom: "18px",
};

const inputStyle = {
  display: "block",
  width: "100%",
  maxWidth: "420px",
  padding: "10px",
  marginBottom: "10px",
  borderRadius: "6px",
  border: "1px solid #ccc",
};

const buttonStyle = (bg) => ({
  display: "block",
  background: bg,
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  padding: "10px 14px",
  marginBottom: "12px",
  cursor: "pointer",
});

const messageStyle = {
  background: "#fff3cd",
  padding: "10px",
  borderRadius: "6px",
};

const successStyle = {
  background: "#e8f5e9",
  color: "#1b5e20",
  fontWeight: "bold",
  padding: "10px",
  borderRadius: "6px",
};

export default SupportOtpPanel;